module.exports = __webpack_public_path__ + "static/media/logo_tc4.ee1fb86d.png";